/**
 * This file is part of CNT: Sindicats.
 *
 * CNT: Sindicats is free software: you can redistribute it and/or modify it
 * under the terms of the GNU General Public License as published by the Free
 * Software Foundation, either version 2 of the License, or any later version.
 *
 * CNT: Sindicats is distributed in the hope that it will be useful, but
 * WITHOUT ANY WARRANTY; without even the implied warranty of MERCHANTABILITY
 * or FITNESS FOR A PARTICULAR PURPOSE.  See the GNU General Public License for
 * more details.
 *
 * You should have received a copy of the GNU General Public License along with
 * CNT: Sindicats.  If not, see <https://www.gnu.org/licenses/>.
 */
import { MapContainer, TileLayer } from "react-leaflet";
import { useSelect } from '@wordpress/data';

import Syndicate from "./Syndicate";
import ComponentResize from "./ComponentResize";
import store from './store';


export default function SyndicateMap( { children, zoom, scrollWheelZoom } ) {
	const syndicate = useSelect( ( select ) => {
		return select( store.name ).getSyndicate();
	}, [] );

	return (
		<>
			{ syndicate && <MapContainer
				center={ syndicate.location }
				zoom={ zoom }
				scrollWheelZoom={ scrollWheelZoom }
				style={ {
					height: '100%',
				} }
			>
				<ComponentResize/>
				{ children }
				<TileLayer
					attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
					url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
				/>
				<Syndicate syndicate={ syndicate }/>
			</MapContainer> }
		</>
	);
}
